"use client";

import { c as _c } from "react/compiler-runtime";
import { LuCalendar } from "react-icons/lu";
import { Button } from "../button";
import { Popover, PopoverContent, PopoverTrigger } from "../popover";
import { formatDate, set } from "date-fns";
import { Calendar } from "../calendar";
import { TimePicker } from "./time-picker";
import { Matcher } from "react-day-picker";
import { useMemo, useRef, useState } from "react";
import { useDateLocale } from "@/app/[lng]/_components/datelocale-context";
type Props = {
  onChange: (date: Date | undefined) => void;
  value: Date | undefined;
  defaultValue?: Date;
  disabled?: Matcher | Matcher[] | undefined;
  className?: string;
  onlyDate?: boolean;
  triggerClassName?: string;
};
const DateTimePicker = t0 => {
  const $ = _c(28);
  const {
    value,
    onChange,
    defaultValue,
    disabled,
    className,
    triggerClassName,
    onlyDate
  } = t0;
  const DateFnsLocale = useDateLocale();
  const timepickerRef = useRef(null);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  let t1;
  bb0: {
    if (value && value instanceof Date && !isNaN(value.valueOf())) {
      ;
      try {
        let t3;
        if ($[0] !== DateFnsLocale || $[1] !== value) {
          t3 = formatDate(value, "P", {
            locale: DateFnsLocale
          });
          $[0] = DateFnsLocale;
          $[1] = value;
          $[2] = t3;
        } else {
          t3 = $[2];
        }
        const val = t3;
        t1 = val;
        break bb0;
      } catch (t2) {
        const e = t2;
        if (e instanceof Error) {
          console.log("Error for value " + value.toString() + ": " + e.message);
        }
      }
    }
    t1 = "---";
  }
  const displayedDate = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LuCalendar />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== displayedDate || $[5] !== triggerClassName) {
    t3 = <PopoverTrigger asChild={true}><Button variant="outline" className={triggerClassName}>{displayedDate}{t2}</Button></PopoverTrigger>;
    $[4] = displayedDate;
    $[5] = triggerClassName;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== onChange || $[8] !== value) {
    t4 = date => {
      setIsCalendarOpen(false);
      const result = date ? value ? set(value, {
        year: date.getFullYear(),
        month: date.getMonth(),
        date: date.getDate()
      }) : date : undefined;
      onChange(result);
      timepickerRef.current?.focus();
    };
    $[7] = onChange;
    $[8] = value;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== DateFnsLocale || $[11] !== disabled || $[12] !== t4 || $[13] !== value) {
    t5 = <PopoverContent className="h-[400px]"><Calendar mode="single" showOutsideDays={true} selected={value} disabled={disabled} onSelect={t4} locale={DateFnsLocale} /></PopoverContent>;
    $[10] = DateFnsLocale;
    $[11] = disabled;
    $[12] = t4;
    $[13] = value;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== isCalendarOpen || $[16] !== t3 || $[17] !== t5) {
    t6 = <Popover open={isCalendarOpen} onOpenChange={setIsCalendarOpen}>{t3}{t5}</Popover>;
    $[15] = isCalendarOpen;
    $[16] = t3;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== defaultValue || $[20] !== onChange || $[21] !== onlyDate || $[22] !== value) {
    t7 = !onlyDate && <TimePicker ref={timepickerRef} className="max-w-max" defaultValue={defaultValue ?? value} smallestTimeVisible="minutes" onChange={onChange} />;
    $[19] = defaultValue;
    $[20] = onChange;
    $[21] = onlyDate;
    $[22] = value;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== className || $[25] !== t6 || $[26] !== t7) {
    t8 = <div className={className}>{t6}{t7}</div>;
    $[24] = className;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  return t8;
};
export { DateTimePicker };